import React, {
  useMemo,
  // useEffect,
  // useState
} from "react";
import EmailWhite from "../assets/public/email_white.svg";
import LogoWhite from "../assets/public/logo_white.svg";
import PhoneWhite from "../assets/public/phone_white.svg";
import WaWhite from "../assets/public/wa_white.svg";
// import { useTranslation } from 'react-i18next';
// import ArrowDownLineIcon from '@rsuite/icons/ArrowDownLine';
// import ArrowUpLineIcon from '@rsuite/icons/ArrowUpLine';
// import GlobalIcon from '@rsuite/icons/Global';

const Footer = () => {
  // const { i18n } = useTranslation();
  // const [isOpen, setIsOpen] = useState(false);
  // const currentLanguage = i18n.language;

  // const toggleDropdown = () => {
  //   setIsOpen(!isOpen);
  // };

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  //   setIsOpen(false);
  // };

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <>
      <div className="mobile-view">
        <footer className="page-footer backdrop-opacity-10">
          <div className="grid grid-cols-1 place-items-center">
            <img src={LogoWhite} width="60%" alt="" />
          </div>

          <div>
            <div className="grid grid-cols-1 place-items-center">
              <div className="flex justify-center ...">
                <div>
                  <img
                    src={EmailWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;&nbsp;
                </div>
                <div>
                  <span style={{ fontSize: "15px" }}>info@magnetfx.co.id</span>
                </div>
              </div>
              <div className="mt-2 flex justify-center ...">
                <div>
                  <img
                    src={PhoneWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;&nbsp;
                </div>
                <div>
                  <a style={{ color: "white" }} href="tel:(021) 250 6336">
                    <span style={{ fontSize: "15px" }}>(021) 250 6336</span>
                  </a>
                </div>
              </div>
              <div className="mt-2 flex justify-center ...">
                <div>
                  <img
                    src={WaWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;&nbsp;
                </div>
                <div>
                  <a
                    style={{ color: "white" }}
                    href="https://api.whatsapp.com/send?phone=6287835355526&text=Halo"
                  >
                    <span style={{ fontSize: "15px" }}>0878-3535-5526</span>
                  </a>
                </div>
              </div>
              <div
                className="mt-2 flex justify-center"
                style={{ textAlign: "center" }}
              >
                <div>
                  <span style={{ fontSize: "14px" }}>
                    &copy; 2021 - {currentYear} www.magnetfx.co id – All Rights
                    Reserved
                  </span>
                </div>
              </div>
              {/* <div className="mt-2 flex justify-center ...">
              <div className="relative">
              <button
                    className="flex w-48 items-center justify-between px-2 py-1 text-white bg-transparent rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onClick={toggleDropdown}
                  >
                    <span>
                      <GlobalIcon className="mr-1" />
                      {currentLanguage === 'id' ? 'Bahasa Indonesia' : 'English'}
                    </span>
                    {
                      isOpen ? (
                        <ArrowUpLineIcon />
                        ) : (
                        <ArrowDownLineIcon />
                      )
                    }
                  </button>
                {isOpen && (
                  <div className="absolute right-0 w-48 border rounded border-gray-300 shadow-lg">
                    <ul className="list-none" style={{listStyle: 'none'}}>
                        <li
                          className="px-2 cursor-pointer hover:bg-gray-100"
                          style={{cursor: 'pointer'}}
                          onClick={() => changeLanguage('id')}
                        >
                          Bahasa Indonesia
                        </li>
                        <li
                          className="px-2 cursor-pointer hover:bg-gray-100"
                          style={{cursor: 'pointer'}}
                          onClick={() => changeLanguage('en')}
                        >
                          English
                        </li>
                    </ul>
                  </div>
                )}
              </div>
            </div> */}
            </div>
          </div>
        </footer>
      </div>
      <div className="mobile-hide">
        <footer className="page-footer backdrop-opacity-10">
          <div className="mobile-hide grid grid-cols-6">
            <div className="show_hide">
              <img src={LogoWhite} width="180px" alt="" />
            </div>

            <div className="show_hide col-span-3 ml-6">
              <div className="grid grid-cols-4">
                <div className="w-[100%] col-span-2">
                  <img
                    src={EmailWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;
                  <span style={{ fontSize: "15px" }}>info@magnetfx.co.id</span>
                </div>

                <div>
                  <img
                    src={PhoneWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;
                  <a style={{ color: "white" }} href="tel:(021) 250 6336">
                    <span style={{ fontSize: "15px" }}>(021) 250 6336</span>
                  </a>
                </div>

                <div>
                  <img
                    src={WaWhite}
                    width="20px"
                    className="float-left"
                    alt=""
                  />
                  &nbsp;
                  <a
                    style={{ color: "white" }}
                    href="https://api.whatsapp.com/send?phone=6287835355526&text=Halo"
                  >
                    <span style={{ fontSize: "15px" }}>0878-3535-5526</span>
                  </a>
                </div>

                <div className="mobile-hide col-span-3 pt-2">
                  &copy; 2021 - {currentYear} www.magnetfx.co.id – All Rights
                  Reserved
                </div>
                {/* <div className="mobile-hide col-span-3 pt-2">
                <div className="relative">
                  <button
                    className="flex w-48 items-center justify-between px-2 py-1 text-white bg-transparent rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onClick={toggleDropdown}
                  >
                    <span>
                      <GlobalIcon className="mr-1" />
                      {currentLanguage === 'id' ? 'Bahasa Indonesia' : 'English'}
                    </span>
                    {
                      isOpen ? (
                        <ArrowUpLineIcon />
                        ) : (
                        <ArrowDownLineIcon />
                      )
                    }
                  </button>
                  {isOpen && (
                    <div className="absolute w-48 border rounded border-gray-300 shadow-lg">
                      <ul className="list-none" style={{listStyle: 'none'}}>
                          <li
                            className="px-2 cursor-pointer hover:bg-gray-100"
                            style={{cursor: 'pointer'}}
                            onClick={() => changeLanguage('id')}
                          >
                            Bahasa Indonesia
                          </li>
                          <li
                            className="px-2 cursor-pointer hover:bg-gray-100"
                            style={{cursor: 'pointer'}}
                            onClick={() => changeLanguage('en')}
                          >
                            English
                          </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Footer;
